<template>
    <div style="text-align: center;" class="content">
        <h1>In the future, we will update the results of the experiment verification on this page!</h1>
    </div>
</template>

<script>
    export default {
        name: "experimentalValidation"
    }
</script>

<style scoped>

    .content{
        /*background-color: #cc85d9;*/

        /*width: 100%;*/

        /*!*position: absolute;*!*/

        /*top: 100px;*/

        /*bottom: 200px;*/

        /*left: 0px;*/
    }
</style>